// Internal modules
import { apolloClient, getLocale } from '@/lib';
import { SUGGESTED_DEFAULT_LANGUAGES_QUERY } from '../queries';

/**
 * For the suggested default language query we reuse the initial
 * language and country to ensure that the data is in the Apollo cache. The
 * two fields we need from that query, country code and language code, aren't
 * dependent on the country or language so using the initial values is fine.
 */
const { country: INITIAL_COUNTRY, language: INITIAL_LANGUAGE } = getLocale();

export const readSuggestedLanguagesQuery = () => {
  const { localeMetadata } = apolloClient.readQuery({
    query: SUGGESTED_DEFAULT_LANGUAGES_QUERY,
    variables: {
      countryCode: INITIAL_COUNTRY,
      languageCode: INITIAL_LANGUAGE,
    },
  });

  /**
   * The suggestedDefaultLanguage is a field on the objects in the territories
   * array. E.G.
   *  [
   *    { code: 'FR', suggestedDefaultLanguage: 'fr' },
   *    { code: 'FR', suggestedDefaultLanguage: 'fr' },
   *    { code: 'US', suggestedDefaultLanguage: 'en' },
   *    etc...
   *  ]
   */
  return localeMetadata.territories;
};
